import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Field.st.css.js';
import { dataHooks } from '../../constants';
const Field = ({ noPadding = false, divider = 'auto', children, }) => {
    return (React.createElement("div", { className: st(classes.root, {
            padded: !noPadding,
            divider: String(divider),
        }), "data-hook": dataHooks.sidePanelField, "data-hoverable-action-trigger": true }, children));
};
Field.displayName = 'Field';
Field.propTypes = {
    noPadding: PropTypes.any,
    divider: PropTypes.any,
    children: PropTypes.any,
};
export default Field;
//# sourceMappingURL=Field.js.map